// drag-item.tsx
import React, { useRef, PropsWithChildren } from "react";
import { Checkbox } from "antd";
import { useDrag, useDrop } from "react-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

interface Props {
  id: string;
  index: number;
  label: string;
  checked: boolean;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  onToggle: () => void;
  isDragDisabled?: boolean;
  isCheckDisabled?: boolean;
  disabled?: boolean;
  type: "parent" | "child";
}

const DragItem: React.FC<PropsWithChildren<Props>> = ({
  id,
  index,
  label,
  checked,
  moveItem,
  onToggle,
  isDragDisabled = false,
  isCheckDisabled = false,
  disabled,
  children,
  type,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const [, drop] = useDrop({
    accept: type,
    hover(item: { index: number }) {
      if (item.index !== index && !isDragDisabled) {
        moveItem(item.index, index);
        item.index = index;
      }
    },
  });

  const [, drag] = useDrag({
    type,
    item: { id, index },
    canDrag: !isDragDisabled,
  });

  drag(drop(ref));

  return (
    <div
      ref={ref}
      onClick={(e) => e.stopPropagation()}
      className="item-drag"
      style={{
        cursor: isDragDisabled ? "not-allowed" : "move",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: 40,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#F7FAFF",
          }}
        >
          <FontAwesomeIcon icon={faBars} style={{ color: "#888", fontSize: 16 }} />
        </div>
        <div style={{ paddingLeft: 12 }}>
          <Checkbox checked={checked} onChange={onToggle} disabled={isCheckDisabled || disabled}>
            {label}
          </Checkbox>
        </div>
      </div>

      {children && <div style={{ paddingLeft: 40 }}>{children}</div>}
    </div>
  );
};

export default DragItem;
